import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const StoreidExp = () => {
  const details = [
    { label: 'Store ID reference', value: ' ' },
  ]

  const expsi = [
    {
        category: 'Production',
        items: [
          { store: 'BlueCube (Pulse/CLA)', storeId: 'CKL89999' },
          { store: 'Dealer (Pulse/CLA)', storeId: 'CKL89998' },
          { store: 'Enterprise (BIZ partner/SFA)', storeId: '99974' },
          { store: 'estore', storeId: 'CKL47948'},
        ],
      },
      {
        category: 'Testbed',
        items: [
          { store: 'BlueCube (Pulse/CLA)', storeId: 'BCC10000KUL' },
          { store: 'Dealer (Pulse/CLA)', storeId: 'SWK50034' },
          { store: 'Enterprise (BIZ partner/SFA)', storeId: '99974' },
          { store: 'estore', storeId: 'CKL47948'},
        ],
      },
  ];

  const addinfo = [
    { label: 'Additional information', value: 'The brackets indicates which channel the individual should refer to, in order to know what store id should be entered into the form, default store ID used are bluecube.', 
     },
  ]

  return (
    <>
      <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {details.map((row) => (
                  <TableRow key={row.label}>
                    <TableCell component="th" scope="row">{row.label}</TableCell>
                    <TableCell colSpan={4}>{row.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
      </TableContainer>

      <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Environment</TableCell>
            <TableCell>STORE</TableCell>
            <TableCell>STORE ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {expsi.map((category) => (
            <React.Fragment key={category.category}>
              {category.items.map((item, index) => (
                <TableRow key={`${category.category}-${item.store}`}>
                  {index === 0 && (
                    <TableCell rowSpan={category.items.length}>
                      {category.category}
                    </TableCell>
                  )}
                  <TableCell>{item.store}</TableCell>
                  <TableCell>{item.storeId}</TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
      </TableContainer>

      <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {addinfo.map((row) => (
                  <TableRow key={row.label}>
                    <TableCell component="th" scope="row">{row.label}</TableCell>
                    <TableCell colSpan={4}>{row.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
      </TableContainer>
    </>
  );
};

export default StoreidExp;